const JOB_STATES = {
    IDLE: 'idle',
    STARTED: 'started',
    COMPLETED: 'completed',
    READY:'ready',
}

module.exports = JOB_STATES